import { Scene, Input   } from "phaser";
import {
    backStaticAnimation, leftStaticAnimation, mapHandler, reposeAnimation,
    rightStaticAnimation, turnStaticAnimation, upStaticAnimation, walkAnimation, lightstickAnimation
} from '../../phaser/create';
import { walkHandler } from '../../phaser/update';
import FullScreen from "../../phaser/components/fullScreen";
import PauseButton from "../../phaser/components/pauseButton";
import HelpButton from "../../phaser/components/helpButton";
import LightstickCounter from "../../phaser/components/lightstickCounter";
import Joystick from "../../phaser/components/joystick";
import ButtonPressed from "../../phaser/components/buttonPressed";

const levels = ['chase-me', 'good-night', 'fly-high', 'you-and-i', 'what', 'piri', 'deja-vu', 'scream', 'boca', 'odd-eye', 'because', 'maison', 'reason'];
const levelsAvailable = ['chase-me', 'good-night', 'fly-high', 'you-and-i', 'what', 'piri', 'deja-vu', 'scream', 'boca', 'odd-eye', 'because', 'maison'];
const songsAvailables = ['fullmoonSong', 'bonvoyageSong', 'justiceSong', 'maydaySong', 'ootdSong', 'risingSong', 'visionSong'];

let cursors;
let walls;

let characterSelected;
let objCharacter;
let objDoor = {};
let activeLevel = {};
let timeoutHelp;
let timeoutHelpMessage;
// let timeoutDialogs;
let isOverDoor = {};
let helpDoor = {};
// let instructionDoors = 'INTERACT: SPACEBAR';
let finishLevel = 'LEVEL COMPLETED';
let footsteps;
let showInstructions = true;
let instructionsHandler = 0;
let gameSettings;
let defaultSettings = '1'
let charactersWin = {};
let lastCoordenates = null;

let trys;

export default class Hallway extends Scene {

    constructor() {
        super({ key: "Hallway" });
    }
    init(data) {
        this.events.off('buttonNext-dialogModal');
        characterSelected = data.characterSelected;
        this.startAll = true;
        trys = localStorage.getItem('td');
        this.finishLevels = JSON.parse(localStorage.getItem('noL')) || [];

        if (data.loadAgain) {
            showInstructions = !data.loadAgain;
            this.startAll = false;
            this.ppalSong.stop();
            
            this.ppalSong = null;

            if (this.finishLevels.length < 7 || this.finishLevels.length > 7) {
                this.dialogModal._createImageDialog(this, 'dialog-gameover', 'dialog-test');
    
                // this.dialogModal._createWindow(this, 'dialog-instructions', null, true)
                this.dialogModal.setText("I'm back in this hallway. \nI need to find the lightsticks if I want to escape from this place.".toUpperCase(), `${characterSelected}-hallway`, false, false)
            }

            if(data.lastCoordenates) {
                lastCoordenates = data.lastCoordenates;
            }
        }

        instructionsHandler = 0;
        const sI = localStorage.getItem('sI');

        if (sI !== "1") {
            showInstructions = true;
        } else {
            showInstructions = false;
        }
    }

    preload() {
        // let file = 'thick_8x8'; // Nombre base de tu fuente
        // this.load.bitmapFont('pixelfont', 'fonts/' + file + '.png', 'fonts/' + file + '.xml');
        // this.load.plugin('DialogModalPlugin', DialogModalPlugin);


        if (this.sys.game.device.os.desktop) {
            this.isMobile = false;
        }
        else {
            this.isMobile = true;
            // instructionDoors = 'INTERACT: SPACEBAR';
        }

        cursors = this.input.keyboard.createCursorKeys();

    }
    create() {
        this.dialogModal = this.plugins.get('dialogModal');

        gameSettings = localStorage.getItem('sound');
        if (gameSettings === null) {
            localStorage.setItem('sound', 1);
            gameSettings = defaultSettings;
        }

        this.events.on('pause', () => {
            if(this.joystickManager) {
                this.joystickManager.pause();
            }
            this.startAll = false;
        });

        this.events.on(`resume`, (scene, args) => {
            this.sound.mute = false;
            if (args && args.goStart) {
                footsteps.stop();
                this.ppalSong.stop();
                this.scene.stop();
    window.removeEventListener("blur", this.onBlurHandler);

                if(this.joystickManager) {
                    this.joystickManager.destroyTest();
                    this.joystickManager = null;
                }
                this.events.off('buttonNext-dialogModal');

                this.scene.start(`Start`);
            } else {

                if(!showInstructions) {
                    this.startAll = true;
                }

                // if (this.isMobile) {
                //     this.joystickManager = new Joystick(objCharacter, `${characterSelected}-hallway`, 300);
                // }        
                gameSettings = localStorage.getItem('sound');
                if (gameSettings === '0') {
                    if (this.ppalSong.isPlaying) {
                        this.ppalSong.stop()
                    }
                } else {
                    if (!this.ppalSong.isPlaying) {
                        this.ppalSong.play();
                    }
                }
            }
        });

        this.cameras.main.setBounds(0, 0, 3684, 450);
        this.physics.world.setBounds(0, 0, 3684, 450);

        const songRandom = songsAvailables[Math.floor(Math.random() * songsAvailables.length)];

        this.ppalSong = this.sound.add(songRandom, { loop: false, volume: 0.2 });
        if (gameSettings === '1') {
            this.ppalSong.play();
        }

        this.ppalSong.on('complete', () => {
            let newRandom = songsAvailables[Math.floor(Math.random() * songsAvailables.length)];

            while(newRandom === songRandom) {
                newRandom = songsAvailables[Math.floor(Math.random() * songsAvailables.length)];
            }

            this.ppalSong = this.sound.add(newRandom, { loop: false, volume: 0.2 });

            if (gameSettings === '1') {
                this.ppalSong.play();
            }
        });

        // if(showInstructions) {
        //     // this.buttonFullscreen = new FullScreen(this);
        //     // this.buttonSettings = new SettingsButton(this);
        //     this.dialogModal._createImageDialog(this, 'dialog-instructions', 'dialog-test');

        //     // this.dialogModal._createWindow(this, 'dialog-instructions', null, true)
        //     this.dialogModal.setText("Where am I? Is this a hotel? It feels strangely familiar. \nThere are 13 doors in this hallway, each with a number. \nCould it be a date? Also, there's a note here...", `${characterSelected}-hallway`, false, true)

        // } else {
        this._createAll();
        //     showInstructions = false;
        // }

        this.spaceBar = this.input.keyboard.addKey(Input.Keyboard.KeyCodes.SPACE);


        this.events.on('buttonNext-dialogModal', (data) => {
            instructionsHandler++;

            if (data.id === 'dialog-instructions') {
                switch (instructionsHandler) {
                    case 1:
                        this.dialogModal.setText("Hello, welcome to your nightmare. \nIf you want to escape, you must collect at least 7 lightsticks \nand cross the last door in the hallway to wake up from this nightmare.".toUpperCase(), `note-test`, false, false);
                        break;
                    case 2:
                        this.dialogModal.setText("It's all up to you... \nbut remember, you're not alone.".toUpperCase(), `note-test`, false, false);
                        break;
                    case 3:
                        this.dialogModal.setText("7 lightsticks. \nI need to find them if I want to escape from this place".toUpperCase(), `${characterSelected}-hallway`, false, false);
                        break;
                    case 4:
                        this.dialogModal.close();
                        showInstructions = false;
                        this.startAll = true;
                        localStorage.setItem('sI', 1);
                        break;
                }
            }

            // if (data.id === 'dialog-dejavu') {
            //     this.dialogModal.close();
            //     this.startAll = true;
            // }

            if (data.id === 'dialog-gameover') {
                this.dialogModal.close();
                this.startAll = true;
            }

            if (data.id === 'dialog-7') {
                switch (instructionsHandler) {
                    case 1:
                        this.dialogModal.setText("Now, I face a tough decision. \nShould I move forward through the last door and \nwake up from this nightmare? \nOr should I continue searching for more lightsticks \nin this mysterious hallway?".toUpperCase(), `${characterSelected}-hallway`, false, false);
                        break;
                    case 2:
                        this.dialogModal.setText("This choice is difficult, \nbut I know that regardless of what I decide, \nthese moments and emotions will stay with me forever.".toUpperCase(), `${characterSelected}-hallway`, false, false);
                        break;
                    case 3:
                        this.dialogModal.close();
                        this.startAll = true;
                        showInstructions = false;
                        break;
                }
            }
        }, this);


    }


    update() {

        if (!showInstructions && this.startAll) {
            this.screenCenterX = this.cameras.main.worldView.x + this.cameras.main.width / 2;

            if (!this.isMobile) {
                    walkHandler(cursors, objCharacter, 300, `${characterSelected}-hallway`);
            } else {
                if(this.joystickManager) {

                    this.joystickManager.show();
                }
            }

            if ((!this.isMobile && (cursors.left.isDown || cursors.right.isDown || cursors.up.isDown || cursors.down.isDown))) {
                if (this.playing !== true) {
                    if (gameSettings === '1') {
                        footsteps.play();
                        this.playing = true;
                    }
                }

            } else {
                this.playing = false;
                footsteps.stop();
            }


        } else {
            if(this.isMobile) {
                if(this.joystickManager) {

                    this.joystickManager.pause();
                }
            }
        }

    }

    _createAll() {
        this.playing = false;
        const map = mapHandler(this, 'hallway-3', false, 8,8 );
        walls = map.walls;
        map.ground.setScale(3);
        walls.setScale(3);

        this.walls2 = map.map.createLayer('Walls2', map.tileset, 0, 0);
        this.walls2.setScale(3)
        this.walls2.setCollisionByProperty({ collides: true });

        footsteps = this.sound.add(`footsteps`, { loop: true, rate: 2 });


        let startX = 152;
        let startY = 162;
        let startYWin = 212;

        for (const [index, level] of levels.entries()) {
            if (index > 0) {
                startX += 282;
            }

            activeLevel[level] = false;

            objDoor[level] = this.physics.add.sprite(startX, startY, `door-${level}`).setScale(3).setInteractive();

            if (trys && level === 'deja-vu' && characterSelected !== 'yoohyeon') {
                objDoor[level] = this.physics.add.sprite(startX, startY, `door-block`).setScale(3).setInteractive();
            }

            charactersWin[index] = this.physics.add.sprite(startX, startYWin, 'somnia').setScale(2.5).setVisible(false);


            // switch(index) {
            //     case 0:
            //         charactersWin[index] = this.physics.add.sprite(startX, startYWin, 'jiu-hallway').setScale(2.5).setVisible(false);
            //         // charactersWin[index].anims.play(`lightstick-jiu-hallway`, true);
            //         break;
            //     case 1:
            //         charactersWin[index] = this.physics.add.sprite(startX, startYWin, 'sua-hallway').setScale(2.5).setVisible(false);
            //         // charactersWin[index].anims.play(`lightstick-sua-hallway`, true);
            //         break;
            //     case 2:
            //         charactersWin[index] = this.physics.add.sprite(startX, startYWin, 'siyeon-hallway').setScale(2.5).setVisible(false);
            //         // charactersWin[index].anims.play(`lightstick-siyeon-hallway`, true);
            //         break;
            //     case 3:
            //         charactersWin[index] = this.physics.add.sprite(startX, startYWin, 'handong-hallway').setScale(2.5).setVisible(false);
            //         // charactersWin[index].anims.play(`lightstick-handong-hallway`, true);
            //         break;
            //     case 4:
            //         charactersWin[index] = this.physics.add.sprite(startX, startYWin, 'yoohyeon-hallway').setScale(2.5).setVisible(false);
            //         // charactersWin[index].anims.play(`lightstick-yoohyeon-hallway`, true);
            //         break;
            //     case 5:
            //         charactersWin[index] = this.physics.add.sprite(startX, startYWin, 'dami-hallway').setScale(2.5).setVisible(false);
            //         // charactersWin[index].anims.play(`lightstick-dami-hallway`, true);
            //         break;
            //     case 6:
            //         charactersWin[index] = this.physics.add.sprite(startX, startYWin, 'gahyeon-hallway').setScale(2.5).setVisible(false);
            //         // charactersWin[index].anims.play(`lightstick-gahyeon-hallway`, true);
            //         break;
            //     case 7:
            //         charactersWin[index] = this.physics.add.sprite(startX, startYWin + 20, 'pie').setScale(2.5).setVisible(false);
            //         // charactersWin[index].anims.play(`lightstick-pie`, true);
            //         break;
            //     case 8:
            //         charactersWin[index] = this.physics.add.sprite(startX, startYWin  + 20, 'cherry').setScale(2.5).setVisible(false);
            //         // charactersWin[index].anims.play(`lightstick-cherry`, true);
            //         break;
            //     case 9:
            //         charactersWin[index] = this.physics.add.sprite(startX, startYWin  + 20, 'gatito').setScale(2.5).setVisible(false);
            //         // charactersWin[index].anims.play(`lightstick-gatito`, true);
            //         break;
            //     case 10:
            //         charactersWin[index] = this.physics.add.sprite(startX, startYWin  + 20, 'perrito').setScale(2.5).setVisible(false);
            //         // charactersWin[index].anims.play(`lightstick-perrito`, true);
            //         break;
            //     default:
            //         charactersWin[index] = this.physics.add.sprite(startX, startYWin  + 20, 'cherry').setScale(2.5).setVisible(false);
            //         // charactersWin[index].anims.play(`lightstick-cherry`, true);
            //         break;

            // }

            // if(!levelsAvailable.includes(level)) {
            //     objDoor[level].setPipeline('Grayscale');
            // }

            this.anims.create({
                key: `open-door-${level}`,
                frames: this.anims.generateFrameNumbers(`door-${level}`, { start: 0, end: 3 }),
                frameRate: 7,
                // repeat: -1

            });

            this.anims.create({
                key: `close-door-${level}`,
                frames: this.anims.generateFrameNumbers(`door-${level}`, { start: 3, end: 0 }),
                frameRate: 7,
                // repeat: -1

            });

        }

        this.pie = this.physics.add.sprite(860, 220, 'pie');
        this.pie.setScale(2.5)

        this.cherry = this.physics.add.sprite(1695, 220, 'cherry');
        this.cherry.setScale(2.5)

        this.gatito = this.physics.add.sprite(2555, 220, 'gatito');
        this.gatito.setScale(2.5)
        
        this.perrito = this.physics.add.sprite(3395, 220, 'gatito');
        this.perrito.setScale(2.5)

        objCharacter = this.physics.add.sprite(315, 226, `${characterSelected}-hallway`, 4);
        objCharacter.setScale(2.5)

        if(lastCoordenates) {
            objCharacter.setPosition(lastCoordenates.x, lastCoordenates.y);
       }


        walkAnimation(this, `${characterSelected}-hallway`);
        reposeAnimation(this, `${characterSelected}-hallway`);
        turnStaticAnimation(this, `${characterSelected}-hallway`);
        upStaticAnimation(this, `${characterSelected}-hallway`);
        leftStaticAnimation(this, `${characterSelected}-hallway`);
        rightStaticAnimation(this, `${characterSelected}-hallway`);
        backStaticAnimation(this, `${characterSelected}-hallway`);

        lightstickAnimation(this, `jiu-hallway`);
        lightstickAnimation(this, `sua-hallway`);
        lightstickAnimation(this, `siyeon-hallway`);
        lightstickAnimation(this, `handong-hallway`);
        lightstickAnimation(this, `yoohyeon-hallway`);
        lightstickAnimation(this, `dami-hallway`);
        lightstickAnimation(this, `gahyeon-hallway`);
        lightstickAnimation(this, `somnia`, 0, 2);

        reposeAnimation(this, `pie`);
        lightstickAnimation(this, `pie`, 17, 18);

        reposeAnimation(this, `cherry`);
        lightstickAnimation(this, `cherry`, 17, 18);
        
        reposeAnimation(this, `gatito`);
        lightstickAnimation(this, `gatito`, 3, 5);

        reposeAnimation(this, `perrito`);
        lightstickAnimation(this, `perrito`, 3, 5);


        this.physics.add.collider(objCharacter, walls);

        this.pie.anims.play(`lightstick-pie`, true);
        this.cherry.anims.play(`lightstick-cherry`, true);
        this.gatito.anims.play(`lightstick-gatito`, true);
        this.perrito.anims.play(`lightstick-perrito`, true);

        // this.physics.add.collider(this.pie, this.walls2, () => {
        //     randomDirection(`pie`);
        // }, null, this);
        // this.physics.add.collider(this.cherry, this.walls2, () => {
        //     randomDirection(`cherry`);
        // }, null, this);
        // this.physics.add.collider(this.pie, this.cherry, () => {
        //     randomDirection(`pie`);
        //     randomDirection(`cherry`);
        // }, null, this);

        // helpDoor = this.add.text(0, 10, instructionDoors, { font: "30px CustomFont", fill: "#FFF", stroke: "#101820", strokeThickness: 3 }).setOrigin(0.5).setVisible(false);
        helpDoor = this.add.bitmapText((this.cameras.main.worldView.x + this.cameras.main.width / 2) + 120, 20, 
            'pixelfont', "Interact: spacebar/action button".toUpperCase(), 10,1).setTint(0xffffff).setOrigin(1, 0).setScale(1).setScrollFactor(0).setVisible(false);
        // this.levelNoAvailableText = this.add.text(0, 10, "NO DISPONIBLE", { font: "25px CustomFont", fill: "#8a2a2b	", stroke: "#101820", strokeThickness: 6 }).setOrigin(0.5).setVisible(false);
        this.levelNoAvailableText = this.add.bitmapText((this.cameras.main.worldView.x + this.cameras.main.width / 2) + 60, 20, 
        'pixelfont', "not available".toUpperCase(), 10,1).setTint(0x8a2a2b).setOrigin(1, 0).setScale(1).setScrollFactor(0).setVisible(false);
        this.levelNoAvailableDejaVu = this.add.bitmapText((this.cameras.main.worldView.x + this.cameras.main.width / 2) + 120, 20, 
        'pixelfont', "I'M ALREADY ENTERED HERE . . .".toUpperCase(), 10,1).setTint(0x8a2a2b).setOrigin(1, 0).setScale(1).setScrollFactor(0).setVisible(false);
        // this.finishLevelText = this.add.text(0, 10, finishLevel, { font: "25px CustomFont", fill: "#f2c763	", stroke: "#101820", strokeThickness: 6 }).setOrigin(0.5).setVisible(false);
        this.finishLevelText = this.add.bitmapText((this.cameras.main.worldView.x + this.cameras.main.width / 2) + 60, 20, 
        'pixelfont', finishLevel.toUpperCase(), 10,1).setTint(0xf2c763).setOrigin(1, 0).setScale(1).setScrollFactor(0).setVisible(false);

        this.finishLevels = JSON.parse(localStorage.getItem('noL')) || [];

        let auxReasonCount = 0;

        for (const [index, level] of levels.entries()) {

            if (this.finishLevels.includes(index + 1)) {
                auxReasonCount++;
                charactersWin[index].setVisible(true);
                charactersWin[index].anims.play(`lightstick-somnia`, true);

                // switch(index) {
                //     case 0:
                //         charactersWin[index].setVisible(true);
                //         charactersWin[index].anims.play(`lightstick-jiu-hallway`, true);
                //         break;
                //     case 1:
                //         charactersWin[index].setVisible(true)
                //         setTimeout(() => {
                //             charactersWin[index].anims.play(`lightstick-sua-hallway`, true);
                //         });
                //         break;
                //     case 2:
                //         charactersWin[index].setVisible(true)
                //         setTimeout(() => {
                //             charactersWin[index].anims.play(`lightstick-siyeon-hallway`, true);
                //         }, 100)
                //         break;
                //     case 3:
                //         charactersWin[index].setVisible(true)
                //         setTimeout(() => {
                //             charactersWin[index].anims.play(`lightstick-handong-hallway`, true);
                //         });
                //         break;
                //     case 4:
                //         charactersWin[index].setVisible(true)
                //         setTimeout(() => {
                //             charactersWin[index].anims.play(`lightstick-yoohyeon-hallway`, true);
                //         }, 200)
                //         break;
                //     case 5:
                //         charactersWin[index].setVisible(true)
                //         setTimeout(() => {
                //         charactersWin[index].anims.play(`lightstick-dami-hallway`, true);
                //         }, 300);
                //         break;
                //     case 6:
                //         charactersWin[index].setVisible(true)
                //         setTimeout(() => {
                //         charactersWin[index].anims.play(`lightstick-gahyeon-hallway`, true);
                //         }, 400);
                //         break;
                //     case 7:
                //         charactersWin[index].setVisible(true)
                //         setTimeout(() => {
                //         charactersWin[index].anims.play(`lightstick-pie`, true);
                //         }, 500);
                //         break;
                //     case 8:
                //         charactersWin[index].setVisible(true)
                //         setTimeout(() => {
                //         charactersWin[index].anims.play(`lightstick-cherry`, true);
                //         }, 600);
                //         break;
                //     case 9:
                //         charactersWin[index].setVisible(true)
                //         setTimeout(() => {
                //         charactersWin[index].anims.play(`lightstick-gatito`, true);
                //         }, 700);
                //         break;
                //     case 10:
                //         charactersWin[index].setVisible(true)
                //         setTimeout(() => {
                //         charactersWin[index].anims.play(`lightstick-perrito`, true);
                //         }, 800);
                //         break;
                //     default:
                //         charactersWin[index].setVisible(true)
                //         setTimeout(() => {
                //         charactersWin[index].anims.play(`lightstick-cherry`, true);
                //         }, 900);
                //         break;

                // }
            }

            isOverDoor[level] = false;
            this.countDialogDejavu = 0;
            this.physics.add.overlap(objDoor[level], objCharacter, () => {
                helpDoor.visible = false;
                this.countDialogDejavu++;
                this.levelNoAvailableText.visible = false;
                if (levelsAvailable.includes(level)) {

                    if (this.finishLevels.includes(index + 1)) {
                        this.finishLevelText.visible = true;
                        // this.finishLevelText.setPosition(this.screenCenterX, 10);
                        clearTimeout(timeoutHelp);
                        timeoutHelp = setTimeout(() => {
                            this.finishLevelText.visible = false;
                        });
                    } else {
                        let accessLevel = true;

                        // helpDoor.setPosition(this.screenCenterX, 30);
                        isOverDoor[level] = true;
                        helpDoor.visible = true;
                        if (index === 6 && characterSelected !== 'yoohyeon') {

                            if (trys) {
                                accessLevel = false;
                                helpDoor.visible = false;
                                // if (this.countDialogDejavu === 20) {
                                    this.levelNoAvailableDejaVu.visible = true;

                                    // this.startAll = false;
                                    // this.dialogModal._createImageDialog(this, 'dialog-dejavu', 'dialog-test');

                                    // this.dialogModal.setText("I'M ALREADY ENTERED HERE . . .", `${characterSelected}-hallway`, false, true)
                                // }
                            }
                        }

                        clearTimeout(timeoutHelp);
                        timeoutHelp = setTimeout(() => {
                            isOverDoor[level] = false;
                            this.countDialogDejavu = 0;
                            helpDoor.visible = false;
                        }, 1000);

                        clearTimeout(timeoutHelpMessage);
                        timeoutHelpMessage = setTimeout(() => {
                            helpDoor.visible = false;
                            this.levelNoAvailableDejaVu.visible = false;

                        });


                        if (this.spaceBar.isDown || (this.isMobile && this.buttonAction.isDown)) {
                            if (accessLevel) {
                                clearTimeout(this.timeoutDoor);
                                this.timeoutDoor = setTimeout(() => {
                                    for (const [index, l] of levels.entries()) {
                                        // if(levelsAvailable.includes(l)) {
                                        if (l === level) {
                                            if (activeLevel[l] === false) {
                                                if (isOverDoor[l] === true) {
                                                    objDoor[l].anims.play(`open-door-${l}`, true);
                                                    activeLevel[l] = true;
                                                    this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                                                        if (progress === 1) {
                                                            footsteps.stop();
                                                            this.ppalSong.stop();
                                                            this.scene.stop();
    window.removeEventListener("blur", this.onBlurHandler);

                                                            if(this.joystickManager) {
                                                                this.joystickManager.destroyTest();
                                                                this.joystickManager = null;
                                                            }
                                                            if (l === 'reason') {
                                                                this.scene.start(`Game14`, { characterSelected: characterSelected });
                                                            } else {
                                                                this.scene.start(`Game${index + 1}`, { characterSelected: characterSelected, lastCoordenates: {x: objCharacter.x, y: objCharacter.y} });
                                                            }
                                                        }
                                                    });
                                                }
                                            } else {
                                                objDoor[l].anims.play(`close-door-${l}`, true);
                                                activeLevel[l] = false;
                                            }

                                        } else {

                                            if (activeLevel[l] === true && isOverDoor[l] === false) {

                                                objDoor[l].anims.play(`close-door-${l}`, true);
                                                activeLevel[l] = false;
                                            }
                                        }
                                        // }
                                    }

                                }, 500);
                            }

                        }
                    }

                } else {
                    // this.levelNoAvailableText.setPosition(this.screenCenterX, 10);
                    this.levelNoAvailableText.visible = true;

                    clearTimeout(timeoutHelp);
                    timeoutHelp = setTimeout(() => {
                        this.levelNoAvailableText.visible = false;
                    });
                }

            }, null, this);
        }

        if (auxReasonCount > 6) {
            levelsAvailable.push('reason');
            if (!showInstructions) {
                if (auxReasonCount === 7) {
                    this.startAll = false;
                    this.dialogModal._createImageDialog(this, 'dialog-7', 'dialog-test');
                    this.dialogModal.setText("Wow! Finally, I did it. I have found the 7 lightsticks. \nI feel great joy and excitement as I hold these \namazing lightsticks in my hands. \nThey have been a great motivation for me during this adventure.".toUpperCase(), `${characterSelected}-hallway`, false, false)

                }
            }
        }

        this.cameras.main.startFollow(objCharacter, false);
        objCharacter.anims.play(`repose-${characterSelected}-hallway`, true);

        if (showInstructions) {
            this.dialogModal._createImageDialog(this, 'dialog-instructions', 'dialog-test');
            
            // this.add.bitmapText(170, 365, 
            //     'pixelfont', 
            //     .toUpperCase(), 10).setTint(0x000000).setDepth(1); 

            this.dialogModal.setText("Where am I? Is this a hotel? It feels strangely familiar. \nThere are 13 doors in this hallway, each with a number. \nCould it be a date? Also, there's a note here...".toUpperCase(), `${characterSelected}-hallway`, false, false)

        }


        if (this.isMobile) {

            this.joystickManager = new Joystick(objCharacter, `${characterSelected}-hallway`, 300);
            this.joystickManager.createJoystick();
            this.joystickManager.activate(this.hasLightstick);
            this.buttonAction = new ButtonPressed(this, 700, 500 - 51, `buttonAction`);
            this.buttonAction.setScale(2);
            this.add.existing(this.buttonAction);
        }

        this.buttonFullscreen = new FullScreen(this);
        this.buttonPause = new PauseButton(this, characterSelected);
        this.buttonHelp = new HelpButton(this);
        this.lightstickCounter = new LightstickCounter(this, 30, 16);

        this.onBlurHandler = () => {
            this.buttonPause.pauseByEvent();
        };

        window.addEventListener("blur", this.onBlurHandler);

        // document.addEventListener('visibilitychange', () => {
        //     if (document.visibilityState !== 'visible') {
        //         this.buttonPause.pauseByEvent();
        // } 
        // });

    }

       shutdown() {
    // Este evento de Phaser se dispara cuando la escena se para
    window.removeEventListener("blur", this.onBlurHandler);
}

destroy() {
    // Este evento de Phaser se dispara cuando la escena se elimina por completo
    window.removeEventListener("blur", this.onBlurHandler);
}

}